import { render, staticRenderFns } from "./PatientViewInfo.vue?vue&type=template&id=161aed9a"
import script from "./PatientViewInfo.vue?vue&type=script&lang=js"
export * from "./PatientViewInfo.vue?vue&type=script&lang=js"
import style0 from "./PatientViewInfo.vue?vue&type=style&index=0&id=161aed9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports